import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResetPassComponent } from './auth/reset-pass/reset-pass.component';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path:'login',
    loadChildren:() => import('./auth/login/login.module').then(m => m.LoginModule),
   canActivate: [AuthGuard]
  },
  {
    path:'admin',
    loadChildren:() => import('./layout/layout.module').then(m => m.LayoutModule),
    canActivate:[AuthGuard]
  },
  {
    path: 'reset-pass/:Token',
    component: ResetPassComponent
  },
  {
    path:'**',
    redirectTo:'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
